import GetFupExerciseSettingsRequestModelBase from '../_generated/modelBases/get-fup-exercise-settings-request-model-base';

export default class GetFupExerciseSettingsRequestModel extends GetFupExerciseSettingsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
